module.exports = __webpack_public_path__ + "img/icon-component-label_ShopHeader.5a5b7eed.svg";